// Whenever a product/item is viewed
// https://support.karte.io/post/3SObAcXAvjn5S6kSQ4wuBZ

export default function karteViewItem(item: any, stock_status: boolean) {
  try {
    item.stock_status = stock_status;

    console.log("karte.view_item: ", item);

    (window as any).tracker.track("view_item", item);
  } catch (e) {
    console.log("karte.view_item: ", e);

    if ("tracker" in window) {
      (window as any).tracker.track("_error", {
        message: e.message
      });
    }
  }
}
